const API = {
  url: process.env.REACT_APP_API_URL,
  urlBasecamp: process.env.REACT_APP_API_BASECAMP_URL,
  urlCelery: process.env.REACT_APP_API_CELERY_URL,
  urlDtMood: process.env.REACT_APP_API_DTMOOD,
  urlDtMoodColab: process.env.REACT_APP_API_DTMOOD_COLAB,
  // Algunos entornos lo definen con distintos nombres; dejamos fallback seguro.
  urlDtMoodAdmin:
    process.env.REACT_APP_API_DTMOOD_ADMIN ||
    process.env.REACT_APP_DTMOOD_ADMIN ||
    process.env.REACT_APP_API_DTMOOD_COLAB,
  urlBase: process.env.REACT_APP_BASE_URL,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL,
  keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM,
  keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
}

export default API
